module.exports = "/_next/static/images/Hero@2x-61e6625b8f01df06b5b688620673448c.webp";